export default "/images/unassigned.png?6f95b5fed43dc860c7ef0cbe21f817d4";